import DashboardLayout from '../layouts/DashboardLayout'
import Training from '../pages/training/Training'

export const trainingMenu = {
    path: '/training',
    component: DashboardLayout,
    name: 'Training',
    children: [
        {
            path: '/',
            components: { default: Training },
            meta: {
                roles: ['contact_read', 'dashboard_read'],
                requiresAuth: true,
                breadcrumb: [{
                    title: 'Tài liệu training'
                }]
            },
        },
    ],
}